import { motion } from "framer-motion";
import { LINKS } from "../data/content";
import { WhatsAppIcon } from "./icons";

const FloatingWhatsApp = () => (
  <motion.a
    data-testid="floating-whatsapp-action-button"
    href={LINKS.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Dr. Mugdha on WhatsApp"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.4, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="pulse-ring fixed bottom-6 right-6 z-[60] flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_35px_rgba(37,211,102,0.4)]"
  >
    <WhatsAppIcon className="w-7 h-7" />
  </motion.a>
);

export default FloatingWhatsApp;
